import React, { useState } from 'react';
import { CopyIcon, CheckIcon } from 'lucide-react';
interface CodeBlockProps {
  code: string;
  language?: string;
  className?: string;
}
export function CodeBlock({
  code,
  language = 'text',
  className = ''
}: CodeBlockProps) {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className={`relative group rounded-lg border border-pk-code-border bg-pk-code-bg overflow-hidden ${className}`} data-id="element-144">
      {language && <div className="flex items-center justify-between px-4 py-2 border-b border-pk-code-border bg-pk-code-bg/50" data-id="element-145">
          <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider" data-id="element-146">
            {language}
          </span>
          <button onClick={handleCopy} className="text-muted-foreground hover:text-foreground transition-colors p-1" aria-label="Copy code" data-id="element-147">
            {copied ? <CheckIcon className="w-4 h-4 text-pk-success" data-id="element-148" /> : <CopyIcon className="w-4 h-4" data-id="element-149" />}
          </button>
        </div>}
      {!language && <button onClick={handleCopy} className="absolute top-2 right-2 p-2 text-muted-foreground hover:text-foreground opacity-0 group-hover:opacity-100 transition-opacity bg-pk-code-bg rounded-md border border-pk-code-border" aria-label="Copy code" data-id="element-150">
          {copied ? <CheckIcon className="w-4 h-4 text-pk-success" data-id="element-151" /> : <CopyIcon className="w-4 h-4" data-id="element-152" />}
        </button>}
      <div className="p-4 overflow-x-auto" data-id="element-153">
        <pre className="text-sm font-mono text-foreground/90 whitespace-pre" data-id="element-154">
          <code data-id="element-155">{code}</code>
        </pre>
      </div>
    </div>;
}